import { TextInput, TextLabel } from '@core/components/Inputs';
import { DataBR } from '@format';
import { Grid, Tooltip } from '@material-ui/core';
import SelectConta from 'app/components/Select/SelectConta';
import { contaApi } from 'app/services/api/contaApi';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import { FormikProvider } from 'formik';
import React, { useContext, useEffect } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { ConciliacaoContext } from '../ConciliacaoContext';

const FormularioTransferencia = ({ formik, extrato }) => {
  const [contaBancaria] = useContext(ConciliacaoContext).contaBancaria;

  const tooltip = 'Aqui você pode realizar a transferência de um banco para outro.';

  const isDespesa = extrato && !extrato.transferenciaBancaria && extrato?.valor && extrato?.valor < 0;
  const isReceita = extrato && !extrato.transferenciaBancaria && extrato?.valor && extrato?.valor > 0;

  const _errors = {
    contaOrigem: (formik?.submitCount > 0 || formik?.touched?.contaOrigem) && formik?.errors?.contaOrigem,
    contaDestino: (formik?.submitCount > 0 || formik?.touched?.contaDestino) && formik?.errors?.contaDestino,
  };

  const formikValues = formik?.values;
  useEffect(() => {
    extrato.transferenciaBancariaForm = {
      ...formik.values,
      id: formik.values?.id,
      origemId: formik.values?.contaOrigem?.id,
      destinoId: formik.values?.contaDestino?.id,
      valor: formik.values?.valor,
      data: formik.values?.data,
      descricao: formik.values?.descricao,
    };
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikValues]);

  useEffect(() => {
    if (isDespesa || isReceita) {
      formik.setFieldValue('valor', extrato?.valor);
      formik.setFieldValue('data', extrato?.dataHoraLancamento);

      const fetchData = async () => {
        const conta = await contaApi.getOne(contaBancaria?.contaId);

        if (conta !== undefined || conta !== null) {
          if (extrato?.valor < 0) {
            formik.setFieldValue('contaOrigem', conta.data);
          } else {
            formik.setFieldValue('contaDestino', conta.data);
          }
        }
      };

      fetchData().catch(console.error);
    }
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FormikProvider value={formik}>
        <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          <Tooltip title={tooltip} placement="right-end">
            <button type="button" onClick={() => {}}>
              <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
            </button>
          </Tooltip>
        </Grid>
        <Grid container spacing={2} className="mt-8">
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            {isDespesa ? (
              <TextLabel id="contaOrigem" label="Conta origem" value={formik.values?.contaOrigem?.descricao} />
            ) : (
              <SelectConta
                id="contaOrigem"
                name="contaOrigem"
                label="Conta origem"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values?.contaOrigem || ''}
                disabled={isDespesa}
                required={formik.values?.valor > 0}
                touched={!!_errors?.contaOrigem}
                error={_errors?.contaOrigem}
              />
            )}
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            {isReceita ? (
              <TextLabel id="contaDestino" label="Conta destino" value={formik.values?.contaDestino?.descricao} />
            ) : (
              <SelectConta
                id="contaDestino"
                name="contaDestino"
                label="Conta destino"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values?.contaDestino || ''}
                disabled={isReceita}
                required={formik.values?.valor < 0}
                touched={!!_errors?.contaDestino}
                error={_errors?.contaDestino}
              />
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} className="mt-8">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextInput
              id="descricao"
              name="descricao"
              label="Descrição"
              onChange={formik.handleChange}
              value={formik.values.descricao}
              fullWidth
              variant="outlined"
              maxLength={128}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className="mt-8">
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="valor"
              label="Valor (R$)"
              fullWidth
              value={getCurrencySemSinalMonetario(Math.abs(formik.values?.valor))}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="data" label="Data" fullWidth value={DataBR(formik.values?.data)} />
          </Grid>
        </Grid>
      </FormikProvider>
    </>
  );
};

export default FormularioTransferencia;
